import * as type from './types';
import { createReducer } from "../../util/index";

const initialState = 
{
    data: [],
};

const luckySpinReducer = createReducer(initialState) ({
    //Export the response to the react.js to get the response data based on type name
    [type.INDEX]: (state, action) => ({
        ...state,
        rs: action.value,
    }),
    // [type.PRIZE_GROUP]: (state, action) => ({
    //     ...state,
    //     group: action.value,
    // }),
    [type.STORE]: (state, action) => ({
        ...state,
        store: action.value,
    }),
});

export default luckySpinReducer;